// 工程监理员菜单

let menuProjectSupervisor = [
    	
    // {
    //     path:'/',
    //     component: "HomeView",
    //     redirect: '/home/IndexView',
    //     name: '首页',
    //     parent:true,
    //     children:[
    //         {
    //             pageAddress:"IndexView",
    //             path:"/home/IndexView",
    //             component:"IndexView",
    //             name:"实时数据",
    //         }
    //     ]

    // },
    // {
    //     path: '/p0',
    //     component: "HomeView",
    //     name: '营销管理',
	// 	disable:true,//无权限
    // },
    // {
	// 	path:'/p1',
    //     redirect: '/common/fileList',
    //     component: "HomeView",
    //     name: '运营管理',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"项目进度",
    //             children:[
    //                 // {
    //                 //     pageAddress:"commonPage/projectManage/fileList",
    //                 //     path:"/common/fileList",
    //                 //     component:"fileList",
    //                 //     name:"项目资料管理"
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/projectManage/fileDetail",
    //                     path:"/common/fileDetail",
    //                     component:"fileDetail",
    //                     hidden:true,
    //                     name:"项目资料详情"
    //                 },	
    //             ]
    //         }
    //     ]

    // },
    // {
    //     path: '/p2',
    //     component: "HomeView",
    //     name: '合同管理',
    //     disable:true,//无权限
    // },
    // {
	// 	path:'/p3',
    //     redirect: '/common/engineerList0',
    //     component: "HomeView",
    //     name: '工程管理',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"质监管理",
    //             children:[
    //                 // {
    //                 //     pageAddress:"commonPage/enginnerManage/engineerList0",
    //                 //     path:"/common/engineerList0",
    //                 //     component:"engineerList",
    //                 //     name:"工程总表"
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/enginnerManage/engineerDetail",
    //                     path:"/common/engineerDetail",
    //                     hidden:true, 
    //                     component:"engineerDetail",
    //                     name:"工程详情"
    //                 },
    //                 {
    //                     pageAddress:"CommonContractModifyDetail",
    //                     path:"/common/contractModify/CommonContractModifyDetail",
    //                     hidden:true,
    //                     name:"变更合同详情"
    //                 },
    //                 // {
    //                 //     pageAddress:"commonPage/enginnerManage/pmAllGradeList",
    //                 //     path:"/common/pmAllGradeList",
    //                 //     component:"pmAllGradeList",
    //                 //     name:"项目总监各工地评分汇总表"
    //                 // },		
    //                 // {
    //                 //     pageAddress:"commonPage/enginnerManage/constructionScoreList",
    //                 //     path:"/common/constructionScoreList",
    //                 //     component:"constructionScoreList",
    //                 //     name:"工地检查评分统计表"
    //                 // },	
    //             ]
    //         },
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"公关管理",
    //             children:[
    //                 {
    //                     pageAddress:"commonPage/projectManage/injuriesDetail",
    //                     path:"/common/injuriesDetail",
    //                     component:"injuriesDetail",
    //                     name:"事故详情",
    //                     hidden:true,
    //                 },
    //                 {
    //                     pageAddress:"commonPage/projectManage/injuriesModify",
    //                     path:"/common/injuriesModify",
    //                     component:"injuriesModify",
    //                     name:"编辑事故详情",
    //                     hidden:true,
    //                 },	
    //                 {
    //                     pageAddress:"commonPage/complaintManage/addComplainList",
    //                     path:"/common/addComplainList",
    //                     hidden:true, 
    //                     component:"addComplainList",
    //                     name:"添加投诉"
    //                 },
    //                 {
    //                     pageAddress:"commonPage/complaintManage/complaintDetail",
    //                     path:"/common/complaintDetail",
    //                     hidden:true, 
    //                     component:"complaintDetail",
    //                     name:"投诉详情"
    //                 }
    //             ]
    //         }
    //     ]

    // },
    // {
    //     path: '/p4',
    //     component: "HomeView",
    //     name: '材料管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p5',
    //     component: "HomeView",
    //     name: '财务管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p6',
    //     component: "HomeView",
    //     name: '项目总监管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p7',
    //     component: "HomeView",
    //     name: '客户管理',
    //     disable:true,//无权限
    // },
	{
		path:'/p8',
        redirect: '/cm/information/changePW',
        component: "HomeView",
        name: '系统管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                children:[
                    // {
                    //     pageAddress:"cm/CMChangePWView",
                    //     path:"/cm/information/changePW",
                    //     component:"CMChangePWView",
                    //     name:"修改密码"
                    // }
                ]
            }
        ]

    },
    {
        pageAddress:"commonPage/enginnerManage/startProjectTable",
        path:"/common/startProjectTable",
        component:"startProjectTable",
        hidden:true,
        // name:"开工确认单"
    },
    {
        pageAddress:"commonPage/enginnerManage/constructionScoreDetail",
        path:"/common/constructionScoreDetail",
        component:"constructionScoreDetail",
        hidden:true,
        // name:"工地检查评分统计表"
    },
];

export default menuProjectSupervisor;


// WEBPACK FOOTER //
// ./src/menu/menuProjectSupervisor.js